/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '~/common/types/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type ReferencePublisherInput = {
  name?: string | null | undefined;
  publisherId?: string | null | undefined;
};

export type ReferenceUpsertInput = {
  authors?: Array<string> | null | undefined;
  documentUrl?: string | null | undefined;
  edition?: string | null | undefined;
  id?: string | null | undefined;
  isbn: string;
  publishedDate?: string | null | undefined;
  publishers?: Array<ReferencePublisherInput> | null | undefined;
  shortCode: string;
  tenantId: string;
  title: string;
};

export type UpsertReferenceMutationVariables = Exact<{
  input: Types.ReferenceUpsertInput;
}>;


export type UpsertReferenceMutation = { cnutUpsertReference: { __typename: 'ReferenceUpsertOutput', id: string } };


export const UpsertReferenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertReference"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReferenceUpsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cnutUpsertReference"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpsertReferenceMutation, UpsertReferenceMutationVariables>;